import { Copy01, HomeLine, Link03 } from "@untitledui/icons";
import { PageHeader, PageSection, PageSkeleton, formatJalali } from "@mfa-aff/ui";
import { Button } from "@mfa-aff/ui/components/base/buttons/button";
import { useClipboard } from "@mfa-aff/ui/hooks/use-clipboard";
import { useHome } from "../api/home";
import { useMe, useRecordShare } from "../api/me";
import { EarningsChart } from "./home/EarningsChart";
import { FirstSaleBonusPromise } from "./home/FirstSaleBonusPromise";
import { HomeSlider } from "./home/HomeSlider";
import { LegacyCard } from "./home/LegacyCard";
import { LevelCard } from "./home/LevelCard";
import { MoneyStrip } from "./home/MoneyStrip";
import { MonthCard } from "./home/MonthCard";
import { OnboardingChecklist } from "./home/OnboardingChecklist";
import { RecentCommissions } from "./home/RecentCommissions";
import { SuggestedAction } from "./home/SuggestedAction";

export const HomePage = () => {
    const { data } = useHome();
    const { data: me } = useMe();
    const clipboard = useClipboard();
    const record = useRecordShare();

    if (!data) {
        return <PageSkeleton cards={3} />;
    }

    return (
        <>
            <HomeSlider />

            <PageHeader
                icon={HomeLine}
                title={`سلام ${me?.affiliate.firstName ?? data.partner.displayName.split(" ")[0]}، خوش آمدید`}
                description={`خلاصهٔ درآمد شما تا امروز، ${formatJalali(new Date(), "weekday")}`}
                actions={
                    <>
                        <Button
                            color="secondary"
                            size="md"
                            className="max-sm:flex-1"
                            iconLeading={Copy01}
                            onPress={async () => {
                                if ((await clipboard.copy(data.partner.refCode)).success) record("copy");
                            }}
                            aria-label={`کپی کد معرف ${data.partner.refCode}`}
                        >
                            {clipboard.copied ? (
                                "کپی شد"
                            ) : (
                                <span>
                                    کد معرف:{" "}
                                    <bdi dir="ltr" className="font-semibold latin-digits">
                                        {data.partner.refCode}
                                    </bdi>
                                </span>
                            )}
                        </Button>
                        <Button href="/links" size="md" iconLeading={Link03} className="max-sm:flex-1">
                            ساخت لینک
                        </Button>
                    </>
                }
            />

            <OnboardingChecklist />

            {me?.onboarding.firstSaleBonusRial && (
                <PageSection>
                    <FirstSaleBonusPromise />
                </PageSection>
            )}

            <PageSection>
                <LevelCard level={data.level} />
            </PageSection>

            <PageSection>
                <MoneyStrip balances={data.balances} lifetime={data.lifetime} payoutsEnabled={me?.features.payoutsEnabled ?? false} />
            </PageSection>

            <PageSection>
                <SuggestedAction action={data.suggestedAction} />
            </PageSection>

            <PageSection>
                <div className="grid grid-cols-1 gap-4 lg:gap-6 xl:grid-cols-3">
                    <div className="min-w-0 xl:col-span-2">
                        <EarningsChart series={data.series} />
                    </div>
                    <MonthCard month={data.thisMonth} />
                </div>
            </PageSection>

            <PageSection>
                {data.legacy ? (
                    <div className="grid grid-cols-1 gap-4 lg:gap-6 xl:grid-cols-3">
                        <div className="min-w-0 xl:col-span-2">
                            <RecentCommissions items={data.recent} />
                        </div>
                        <LegacyCard legacy={data.legacy} />
                    </div>
                ) : (
                    <RecentCommissions items={data.recent} />
                )}
            </PageSection>
        </>
    );
};
